module.exports = __webpack_public_path__ + "img/card.91db9328.png";